module.exports = __webpack_public_path__ + "static/img/qmwallet2_quit_confirm.0bf4ab32.png";